(function () {
  var activeEl = null;
  var startX = 0;
  var startScrollLeft = 0;

  function getScrollEl(target) {
    if (!target || !target.closest) return null;
    return target.closest('.collection-feature-scroll');
  }

  function getClientX(e) {
    if (e.clientX != null) return e.clientX;
    if (e.touches && e.touches[0]) return e.touches[0].clientX;
    return null;
  }

  function onDown(e) {
    if (e.type === 'mousedown' && e.button !== 0) return;
    var el = getScrollEl(e.target);
    if (!el) return;
    activeEl = el;
    startX = getClientX(e);
    if (startX == null) return;
    startScrollLeft = el.scrollLeft;
    el.classList.add('is-dragging');
    e.preventDefault();
    e.stopPropagation();
  }

  function onMove(e) {
    if (!activeEl) return;
    var clientX = getClientX(e);
    if (clientX == null) return;
    var walk = startX - clientX;
    activeEl.scrollLeft = Math.max(0, startScrollLeft + walk);
    e.preventDefault();
    e.stopPropagation();
  }

  function onUp() {
    if (activeEl) {
      activeEl.classList.remove('is-dragging');
      activeEl = null;
    }
  }

  document.addEventListener('mousedown', onDown, true);
  document.addEventListener('mousemove', onMove, true);
  document.addEventListener('mouseup', onUp, true);

  document.addEventListener('touchstart', onDown, { passive: false, capture: true });
  document.addEventListener('touchmove', onMove, { passive: false, capture: true });
  document.addEventListener('touchend', onUp, true);
  document.addEventListener('touchcancel', onUp, true);
})();
